// Action types for fetching products
export const FETCH_UPDATE_ORDERS_REQUEST = 'FETCH_UPDATE_ORDERS_REQUEST';
export const FETCH_UPDATE_ORDERS_SUCCESS = 'FETCH_UPDATE_ORDERS_SUCCESS';
export const FETCH_UPDATE_ORDERS_FAILURE = 'FETCH_UPDATE_ORDERS_FAILURE';
export const updateOrdersRequest = (payload) => ({
    type: FETCH_UPDATE_ORDERS_REQUEST,
    payload,
});
export const updateOrdersSuccess = (payload) => ({
    type: FETCH_UPDATE_ORDERS_SUCCESS,
    payload,
});
export const updateOrdersFailure = (error) => ({
    type: FETCH_UPDATE_ORDERS_FAILURE,
    payload: error,
});
